import { render, staticRenderFns } from "./_MODALS_RED.vue?vue&type=template&id=51f606e3&"
import script from "./_MODALS_RED.vue?vue&type=script&lang=js&"
export * from "./_MODALS_RED.vue?vue&type=script&lang=js&"
import style0 from "./_MODALS_RED.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
